import React from 'react';
import { Box } from 'core/components';
import styled from 'styled-components';
import Markdown from 'app/components/markdown/Markdown';
import ToolResultCard from '../components/ToolResultCard';

const ToolMarkdownWrap = styled(Box)`
  overflow: auto;

  h3,
  h4 {
    margin-top: 0;
  }
`;

const DeviceConfigToolResult = ({ tool, onCloseToolResult, isInlineMode = false }) => (
  <ToolResultCard
    tool={tool}
    onCloseToolResult={onCloseToolResult}
    isInlineMode={isInlineMode}
    className="tool-result-device-config"
    title={tool.title || 'Device Configuration Result'}
    minHeight={450}
    overflow="auto"
  >
    <ToolMarkdownWrap>
      <Markdown>{tool.processed_result}</Markdown>
    </ToolMarkdownWrap>
  </ToolResultCard>
);

export default DeviceConfigToolResult;
